/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface DashboardProjectsControllerStreamProjectImageV1$Params {
  projectId: string;
  fileId: string;

/**
 * Optional HTTP date. When provided and the image is not modified since, the server returns 304 Not Modified.
 */
  'If-Modified-Since'?: string;
}

export function dashboardProjectsControllerStreamProjectImageV1(http: HttpClient, rootUrl: string, params: DashboardProjectsControllerStreamProjectImageV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
  const rb = new RequestBuilder(rootUrl, dashboardProjectsControllerStreamProjectImageV1.PATH, 'get');
  if (params) {
    rb.path('projectId', params.projectId, {});
    rb.path('fileId', params.fileId, {});
    rb.header('If-Modified-Since', params['If-Modified-Since'], {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'image/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Blob>;
    })
  );
}

dashboardProjectsControllerStreamProjectImageV1.PATH = '/v1/dashboard/projects/{projectId}/images/{fileId}';
